"use strict";

angular.module('PatientApp').service('ProvidersService', function (VuexStore) {
  return {
    flushAcctActivity: function flushAcctActivity(acctNumber) {
      return VuexStore.dispatch('flushAcctActivity', {
        acctNumber: acctNumber
      });
    }
  };
});